// extracted by mini-css-extract-plugin
export default {"inline":"PJdNWuQT"};